<template>
  <div class="years-ahead-wrapper">
    <div class="mx-auto years-ahead-section grid grid-cols-4">
      <div class="years-ahead-text-box mx-16 col">
        <img class="years-ahead-logo" src="@/images/bh-benefits/years-ahead-logo.svg" alt="Years Ahead Logo" />
        <h2 class="text-h2 my-16">Individualized Senior Care with Years&nbsp;Ahead</h2>
        <p class="text-body">
          Find an in-home care provider or senior care facility. Use the needs assessment, resource library, and dynamic search
          tools to understand your options and find the best fit for your family.
        </p>
        <Button id="years-ahead-button" class="mt-24" variant="arrow" value="Sign Up For Years Ahead" @click="goToSignUpPage" />
      </div>
      <div class="years-ahead-card-container">
        <Card v-for="careType in careTypes" :key="careType.title" :elevation="4" class="years-ahead-card">
          <CompanionCareIcon v-if="careType.title === 'Elder care'" class="mx-auto mb-8" :width="64" :height="64" />
          <AssistedLivingIcon v-if="careType.title === 'Assisted living communities'" class="mx-auto mb-8" />
          <p class="text-body text-center">{{ careType.title }}</p>
        </Card>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import CompanionCareIcon from '@/icons/CompanionCareIcon.vue';
import AssistedLivingIcon from '@/icons/AssistedLivingIcon.vue';
import BHBenefitRoutes from '@/lib/constants/bh_benefit_route_names';

export default {
  name: 'YearsAheadSection',
  components: { Button, Card, CompanionCareIcon, AssistedLivingIcon },
  props: {
    slug: String,
  },
  data(): any {
    return {
      careTypes: [{ title: 'Elder care' }, { title: 'Assisted living communities' }],
    };
  },
  methods: {
    goToSignUpPage(): void {
      this.$router.push({ name: BHBenefitRoutes.YA_SIGNUP, params: { slug: this.slug }, query: { site: 'years_ahead' } });
    },
  },
};
</script>
